/**
 * Configure and register global directives
 */
import type { App } from 'vue';
import { setupPermissionDirective } from './permission';
import { setupLoadingDirective } from './loading';
import {setupBusinessPermission} from './businessPermission';
import {setupPhoneDirective} from './phone';

export function setupGlobDirectives(app: App) {
    setupPermissionDirective(app);
    setupLoadingDirective(app);
    setupBusinessPermission(app);
    setupPhoneDirective(app);
}
